//axios的封装处理
import axios from 'axios'
import { SERVER_CONF } from '@/config/server'
import { getToken, removeToken } from './token'
import router from '@/router'
import i18n from '@/i18n';
//根域名配置
function normalizeBase(base){
    if(!base) return 'http://localhost:8666';
    // 补全协议
    if(/^\d+\.\d+\.\d+\.\d+(:\d+)?$/.test(base)) base = 'http://' + base;
    if(!/^https?:\/\//i.test(base)) base = 'http://' + base.replace(/^\/+/, '');
    return base.replace(/\/$/, '');
}

const request = axios.create({
    baseURL: normalizeBase(SERVER_CONF.BASE_URL) + '/',
    timeout: 5000
})

//添加请求拦截器
request.interceptors.request.use((config) => {

    // 统一来源标识
    if(!config.headers) config.headers = {}
    if(!config.headers.appSource) {
        config.headers.appSource = 'manager'
    }

    //发送请求
    //console.log("请求 = ", config);

    // 注入token
    const token = getToken() ? JSON.parse(getToken()).token : ""
    if (token) {
        const time = new Date().getTime()
        const tokenTime = JSON.parse(getToken()).time
        if (time < tokenTime) {
            config.headers.token = `${token}`
        } else {
            removeToken()
            router.navigate('/login')
            window.alert("用户登录超时，请重新登录！")
            return config
        }
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

//添加响应拦截器
request.interceptors.response.use((response) => {
    return response.data
}, (error) => {
    const t = i18n.t.bind(i18n);
    //测试token失效
    console.log(error)
    if (error.response?.status === 400) {
        window.alert(t('Message.ParameterError'))
        // removeToken()
        // router.navigate('/login')
        window.location.reload()
        return Promise.reject(error)
    }
    if (error.response?.status === 500) {
        window.alert(t('Message.ServerError'))
        removeToken()
        router.navigate('/login')
        window.location.reload()
        return Promise.reject(error)
    }
    if (error.response?.status === 502) {
        window.alert(t('Message.ServerError'))
        removeToken()
        router.navigate('/login')
        window.location.reload()
        return Promise.reject(error)
    }
    if (error.response?.status === 504) {
        window.alert(t('Message.ServerError'))
        removeToken()
        router.navigate('/login')
        window.location.reload()
        return Promise.reject(error)
    }

    return Promise.reject(error)
})

export { request }